<template>

    <div class="modal" tabindex="-1" role="dialog" ref="modalElement">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{state.title}}</h5>
                    <button type="button" class="close" @click="answerOk" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p v-html="state.message"></p>
                </div>
                <div class="modal-footer justify-content-center">
                    <button class="btn "
                            :class="state.successStyle"
                            @click="answerOk">
                        {{messages('button.ok')}}
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import $ from 'jquery'
    import {computed, reactive, ref, watch} from '@vue/composition-api';
    import {messagesMixin} from "../../mixins/messagesMixin";

    export default {
        name: "AckModal",
        mixins: [messagesMixin],
        props: {
            title: {
                type: String
            },
            message: {
                type: String
            },
            show: {
                type: Boolean
            }
        },
        setup(props, {root: {$store}, emit}) {
            // console.log('dialog modal $store', $store)
            const modalElement = ref(null)

            const state = reactive({
                title: computed(() => props.title),
                successStyle: 'btn-primary',
                message: computed(() => props.message),
                successCallback: null,
            })

            const show = computed(() => props.show)

            watch(show, (val) => {
                val ? $(modalElement.value).modal('show') : $(modalElement.value).modal('hide')
            })

            function answerOk() {
                /*if (!!state.successCallback) {*/
                var checkSuccessCallback = !!state.successCallback;
                if (checkSuccessCallback) {
                    state.successCallback()
                }
                emit('update:show', false)
            }

            return {
                state,
                modalElement,
                answerOk,
            }


        }


    }
</script>

<style scoped>

</style>
